import PropTypes from 'prop-types';
import React from 'react';

import Hr from '@hppl/component-hr';

const Heading = ({size, text, classNames, subtext, hasHorizontalRule, id, nodeIndex}) => {
  if (!size || !size.match(/h1|h2|h3|h4|h5|h6/)) size = 'h2';

  let props = {};
  if (classNames) {
      props.className = `${classNames}`;
  }

  if (id) {
      props.id = `${id}`;
  }

  const HeadingTag = size;

  return (
    <React.Fragment key={nodeIndex}>
      <HeadingTag {...props}>
        {text}
        {subtext && !hasHorizontalRule ? (
          <React.Fragment>
            <br />
            <small>{subtext}</small>
          </React.Fragment>
        ) : null}
      </HeadingTag>
      {hasHorizontalRule ? <Hr nodeIndex={0} /> : null}
    </React.Fragment>
  );
};

Heading.propTypes = {
  text: PropTypes.string.isRequired,
  classNames: PropTypes.string,
  size: PropTypes.string,
  subtext: PropTypes.string,
  hasHorizontalRule: PropTypes.bool,
  id: PropTypes.string,
  nodeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default Heading;



// WEBPACK FOOTER //
// ./node_modules/@hpcare/component-wait-times/node_modules/@hppl/component-heading/index.jsx